import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

import Header from 'src/components/Header';
import ScrollAnimation from 'src/components/ScrollAnimation';
import NextLine from 'src/components/NextLine';
import RegisterButton from 'src/components/RegisterButton';

class VirtualTours extends Component {
  render() {
    return (
      <Root>
        <Header
          image={require('src/assets/images/virtualtour/618_Carnarvon_Lobby_1-min.jpg')}
          smallText="Display Suite &amp; Sales Centre"
          largeText="Virtual Tours"
          darken
        />
        <ScrollAnimation>
          <Container>
            <h2>Display Suite</h2>
            <iframe
              width="100%"
              height="755"
              src="https://my.matterport.com/show/?m=uA1d3maYbzc"
              frameBorder="0"
              allowFullScreen
              allow="vr"
              title="Display Suite"
            />
            <h2>Presentation Centre</h2>
            <iframe
              width="100%"
              height="755"
              src="https://my.matterport.com/show/?m=DnscjJX6Tdt"
              frameBorder="0"
              allowFullScreen
              allow="vr"
              title="Presentation Centre"
            />
          </Container>
          <StyledNextLine link="/views" text="Next: The Views" />
          <RegisterButton />
        </ScrollAnimation>
      </Root>
    );
  }
}

export default VirtualTours;

const Root = styled.div`
  h2 {
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 24px;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
    color: ${({ theme }) => theme.colorPrimary};
    padding: 50px 0 25px;
    @media (min-width: ${media.smup}) {
      font-size: 30px;
    }
  }
  iframe {
    height: 52.5vw;
  }
`;

const Container = styled.div`
  padding-top: 35px;
`;

const StyledNextLine = styled(NextLine)`
  margin-top: 100px;
`;



// WEBPACK FOOTER //
// ./src/pages/VirtualTours/VirtualTours.js